module.exports = __webpack_public_path__ + "img/fixed_shower.9a7310b0.svg";